import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard-container" }
const _hoisted_2 = { class: "card-grid" }
const _hoisted_3 = { class: "main-value" }
const _hoisted_4 = { class: "sub-info" }
const _hoisted_5 = { class: "main-value" }
const _hoisted_6 = { class: "sub-info" }
const _hoisted_7 = { class: "main-value" }
const _hoisted_8 = { class: "sub-info" }
const _hoisted_9 = { class: "main-value" }
const _hoisted_10 = { class: "sub-info" }
const _hoisted_11 = { class: "card-grid secondary-grid" }
const _hoisted_12 = { class: "shortcut-container" }
const _hoisted_13 = { class: "shortcut-column" }
const _hoisted_14 = { class: "shortcut-column" }
const _hoisted_15 = { class: "stats-item" }
const _hoisted_16 = { class: "stats-item" }
const _hoisted_17 = { class: "stats-item" }
const _hoisted_18 = { class: "stats-item" }
const _hoisted_19 = { class: "stats-item" }
const _hoisted_20 = { class: "stats-item" }
const _hoisted_21 = { class: "stats-item" }
const _hoisted_22 = { class: "stats-item" }
const _hoisted_23 = { class: "table-container" }
const _hoisted_24 = {
  key: 0,
  style: {"font-size":"32px"}
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { key: 5 }
const _hoisted_28 = { key: 6 }
const _hoisted_29 = { key: 7 }

import { SystemService } from "@/api/services/SystemService";
import { onMounted, reactive } from "vue";
import { Home } from "@/api/models/system/Home";
import {
  AppstoreOutlined,
  UserOutlined,
  PayCircleOutlined,
  ProjectOutlined,
  UsergroupAddOutlined,
  AccountBookOutlined,
  CarOutlined,
  BankOutlined,
  CloudOutlined,
  ContactsOutlined,
  DatabaseOutlined,
  LaptopOutlined,
} from "@ant-design/icons-vue";
import { ColumnType } from "ant-design-vue/lib/table";
import { ToImage } from "@/utils/image";
import dayjs from "dayjs";
import { useRouter } from "vue-router";

// @ts-ignore

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const home = reactive<Home>({});

const router = useRouter();

const handleHome = async () => {
  const res = await SystemService.Home();
  if (res.code === 0) {
    Object.assign(home, res.data);
  }
};

onMounted(() => {
  handleHome();
});

const handleRouter = (path: string) => {
  router.push({ path: path });
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "OpenId",
    dataIndex: "open_id",
    align: "center",
  },
  {
    title: "头像",
    dataIndex: "avatar",
    align: "center",
  },
  {
    title: "用户名",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "来源",
    dataIndex: "origin",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "修改时间",
    dataIndex: "update_at",
    align: "center",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_card, {
        class: "stats-card",
        title: "累计订单金额"
      }, {
        extra: _withCtx(() => [
          _createVNode(_component_a_tag, { color: "blue" }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("订单")
            ])),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, _toDisplayString(home.product_order_total), 1),
          _createElementVNode("div", _hoisted_4, [
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "总订单数", -1)),
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(home.product_order_total_count) + " ", 1),
              _createVNode(_unref(AppstoreOutlined), { class: "icon" })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_card, {
        class: "stats-card",
        title: "系统会员"
      }, {
        extra: _withCtx(() => [
          _createVNode(_component_a_tag, { color: "red" }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("会员")
            ])),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_5, _toDisplayString(home.user_total), 1),
          _createElementVNode("div", _hoisted_6, [
            _cache[11] || (_cache[11] = _createElementVNode("span", null, "今日新增会员数", -1)),
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(home.now_add_user_count) + " ", 1),
              _createVNode(_unref(UserOutlined), { class: "icon" })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_card, {
        class: "stats-card",
        title: "在线储值笔数"
      }, {
        extra: _withCtx(() => [
          _createVNode(_component_a_tag, { color: "green" }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode("数量")
            ])),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_7, _toDisplayString(home.recharge_activity_order_count), 1),
          _createElementVNode("div", _hoisted_8, [
            _cache[13] || (_cache[13] = _createElementVNode("span", null, "今日充值笔数", -1)),
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(home.recharge_activity_order_now_count) + " ", 1),
              _createVNode(_unref(PayCircleOutlined), { class: "icon" })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_card, {
        class: "stats-card",
        title: "出售中的商品"
      }, {
        extra: _withCtx(() => [
          _createVNode(_component_a_tag, { color: "yellow" }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("商品")
            ])),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_9, _toDisplayString(home.product_active_count), 1),
          _createElementVNode("div", _hoisted_10, [
            _cache[15] || (_cache[15] = _createElementVNode("span", null, "仓库中的商品", -1)),
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(home.product_stock_count) + " ", 1),
              _createVNode(_unref(ProjectOutlined), { class: "icon" })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_a_card, {
        class: "shortcut-card",
        title: "快捷方式"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", {
                class: "shortcut-item",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleRouter('/admin/user')))
              }, [
                _createVNode(_unref(UsergroupAddOutlined), { class: "shortcut-icon" }),
                _cache[16] || (_cache[16] = _createElementVNode("span", null, "所有会员", -1))
              ]),
              _createElementVNode("div", {
                class: "shortcut-item",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleRouter('/order/paid')))
              }, [
                _createVNode(_unref(AccountBookOutlined), { class: "shortcut-icon" }),
                _cache[17] || (_cache[17] = _createElementVNode("span", null, "所有订单", -1))
              ]),
              _createElementVNode("div", {
                class: "shortcut-item",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (handleRouter('/order/pending')))
              }, [
                _createVNode(_unref(CarOutlined), { class: "shortcut-icon" }),
                _cache[18] || (_cache[18] = _createElementVNode("span", null, "待发货订单", -1))
              ]),
              _createElementVNode("div", {
                class: "shortcut-item",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (handleRouter('/product/active')))
              }, [
                _createVNode(_unref(BankOutlined), { class: "shortcut-icon" }),
                _cache[19] || (_cache[19] = _createElementVNode("span", null, "所有商品", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: "shortcut-item",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (handleRouter('/journal')))
              }, [
                _createVNode(_unref(CloudOutlined), { class: "shortcut-icon" }),
                _cache[20] || (_cache[20] = _createElementVNode("span", null, "日记存稿", -1))
              ]),
              _createElementVNode("div", {
                class: "shortcut-item",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (handleRouter('/user/recharge')))
              }, [
                _createVNode(_unref(ContactsOutlined), { class: "shortcut-icon" }),
                _cache[21] || (_cache[21] = _createElementVNode("span", null, "在线储值记录", -1))
              ]),
              _createElementVNode("div", {
                class: "shortcut-item",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (handleRouter('/user/reply')))
              }, [
                _createVNode(_unref(DatabaseOutlined), { class: "shortcut-icon" }),
                _cache[22] || (_cache[22] = _createElementVNode("span", null, "回信管理", -1))
              ]),
              _createElementVNode("div", {
                class: "shortcut-item",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (handleRouter('/system')))
              }, [
                _createVNode(_unref(LaptopOutlined), { class: "shortcut-icon" }),
                _cache[23] || (_cache[23] = _createElementVNode("span", null, "系统设置", -1))
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_card, {
        class: "stats-card secondary",
        title: "快捷方式"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _cache[24] || (_cache[24] = _createElementVNode("span", null, "今日订单", -1)),
            _createElementVNode("span", null, _toDisplayString(home.product_order_now_count), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[25] || (_cache[25] = _createElementVNode("span", null, "今日成交额", -1)),
            _createElementVNode("span", null, _toDisplayString(home.product_order_now_total), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[26] || (_cache[26] = _createElementVNode("span", null, "近一个月的订单", -1)),
            _createElementVNode("span", null, _toDisplayString(home.product_order_month_count), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[27] || (_cache[27] = _createElementVNode("span", null, "近一个月成交额", -1)),
            _createElementVNode("span", null, _toDisplayString(home.product_order_month_total), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_card, {
        class: "stats-card secondary",
        title: "代办事项"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_19, [
            _cache[28] || (_cache[28] = _createElementVNode("span", null, "待审核订单", -1)),
            _createElementVNode("span", null, _toDisplayString(home.product_order_pending_count), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[29] || (_cache[29] = _createElementVNode("span", null, "已支付订单", -1)),
            _createElementVNode("span", null, _toDisplayString(home.product_order_paid_count), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[30] || (_cache[30] = _createElementVNode("span", null, "已制作订单", -1)),
            _createElementVNode("span", null, _toDisplayString(home.product_order_processed_count), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[31] || (_cache[31] = _createElementVNode("span", null, "已寄出订单", -1)),
            _createElementVNode("span", null, _toDisplayString(home.product_order_shipped_count), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createVNode(_component_a_table, {
        columns: columns,
        "data-source": home.now_add_user,
        pagination: false,
        bordered: "",
        class: "custom-table"
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.dataIndex === 'is_delete')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (record.is_delete === 1)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 0,
                      color: "green"
                    }, {
                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                        _createTextVNode("正常")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (record.is_delete === 2)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 1,
                      color: "red"
                    }, {
                      default: _withCtx(() => _cache[33] || (_cache[33] = [
                        _createTextVNode("回收站")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : (column.dataIndex === 'status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (record.status === 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "green"
                      }, {
                        default: _withCtx(() => _cache[34] || (_cache[34] = [
                          _createTextVNode("可用")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.status === 2)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "red"
                      }, {
                        default: _withCtx(() => _cache[35] || (_cache[35] = [
                          _createTextVNode("禁用")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : (column.dataIndex === 'avatar')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (record.avatar === '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createVNode(_unref(UserOutlined))
                        ]))
                      : (_openBlock(), _createBlock(_component_a_image, {
                          key: 1,
                          src: _unref(ToImage)(record.avatar),
                          style: {"height":"48px","width":"auto"}
                        }, null, 8, ["src"]))
                  ], 64))
                : (column.dataIndex === 'origin')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      (record.status === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, "微信小程序"))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (column.dataIndex === 'leave_time')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(dayjs)(record.leave_time).format("YYYY-MM-DD HH:mm:ss")), 1))
                    : (column.dataIndex === 'come_time')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(dayjs)(record.come_time).format("YYYY-MM-DD HH:mm:ss")), 1))
                      : (column.dataIndex === 'create_at')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_unref(dayjs)(record.create_at).format("YYYY-MM-DD HH:mm:ss")), 1))
                        : (column.dataIndex === 'update_at')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(dayjs)(record.update_at).format("YYYY-MM-DD HH:mm:ss")), 1))
                          : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data-source"])
    ])
  ]))
}
}

})